import { Dict } from '../../../../types/Dict'

export const MODE_TO_KEY: Dict<string> = {
  info: 'q',
  add: 's',
  remove: 'd',
  change: 'f',
  data: 'a',
  multiselect: 'Shift',
}
